import MxTypography from "@rf-l1/MxTypography";

interface MxDetailCardAgencyPhoneProps {
  phone: string;
}

const MxDetailCardAgentPhone = (props: MxDetailCardAgencyPhoneProps) => {
  return (
    <MxTypography
      color="grey.700"
      variant="caption"
      fontWeight={400}
      autoCopy
      removeAutoCopyStyles
    >
      {props.phone}
    </MxTypography>
  );
};

export default MxDetailCardAgentPhone;
